import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import Image from "../../components/Image/Image.jsx";
import { sessionExpiredMsg } from "../../constants/constants";
class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeout: ""
    };
  }
  componentDidMount() {}
  render() {
    // console.log("MEGHA", this.props.redirectURL)
    // if (this.props.open && this.props.autoClose & this.state.timeout != "") {
    //     this.setState({
    //         timeOut: setTimeout(
    //             () => {
    //                 this.props.modalClose();
    //                 this.setState({timeout: ""});
    //             }, 2000)
    //     });
    // }
    // if (!this.props.open && this.state.timeout != "") {
    //     this.setState({ timeout: "" });
    // }
    if (
      sessionExpiredMsg == this.props.message &&
      !localStorage.getItem("userData")
    ) {
      return null;
    }
    return (
      <div
        id="notifyModal"
        className="modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="costumModalLabel"
        data-keyboard="true"
        aria-hidden="true"
        style={this.props.open ? { display: "block", zIndex: "105000" } : {}}
        onClick={
          this.props.redirectURL
            ? () => {
                this.props.modalClose();
                this.props.history.push(this.props.redirectURL);
              }
            : this.props.modalClose
        }
      >
        <div className="modal-dialog modal-sm modal-dialog-centered">
          <div
            className={
              this.props.notifyType == 2
                ? "modal-content text-center animated bounceIn"
                : "modal-content text-center animated shake"
            }
            tabIndex="0"
          >
            {" "}
            {/* shake class when alert */}
            <div className="modal-body">
              {/* {this.props.notifyType == 1
                                ? ( */}

              <div className="f-modal-alert">
                {this.props.notifyType == 1 ? (
                  <div className="f-modal-icon f-modal-error animate">
                    <span className="f-modal-x-mark">
                      <span className="f-modal-line f-modal-left animateXLeft"></span>
                      <span className="f-modal-line f-modal-right animateXRight"></span>
                    </span>
                    <div className="f-modal-placeholder"></div>
                    <div className="f-modal-fix"></div>
                  </div>
                ) : this.props.notifyType == 2 ? (
                  <div className="f-modal-icon f-modal-success animate">
                    <span className="f-modal-line f-modal-tip animateSuccessTip"></span>
                    <span className="f-modal-line f-modal-long animateSuccessLong"></span>
                    <div className="f-modal-placeholder"></div>
                    <div className="f-modal-fix"></div>
                  </div>
                ) : (
                  <div className="f-modal-icon f-modal-warning animate">
                    <span className="f-modal-body pulseWarningIns"></span>
                    <span className="f-modal-dot pulseWarningIns"></span>
                    <div className="f-modal-placeholder"></div>
                    <div className="f-modal-fix"></div>
                  </div>
                )}
              </div>
              <p>{this.props.message}</p>
              {this.props.redirectURL != "" ? (
                <Link
                  className="btn btn-secondary btn-block"
                  to={this.props.redirectURL}
                  onClick={e => {
                      this.props.modalClose();
                      e.stopPropagation();
                  }}
                >
                  Okay
                </Link>
              ) : (
                <button
                  className="btn btn-secondary btn-block"
                  onClick={e => {
                      this.props.modalClose();
                      console.log('CHCEK IF NO DATA!!!!!!!',this.props.checkIfNoData)
                    if (this.props.checkIfNoData === "noData") {
                      this.props.resetContestProfile();
                    }
                      e.stopPropagation();
                  }}
                >
                  Okay
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ modal, contestProfile }) => {
  const {
    open,
    message,
    withButton,
    buttonText,
    notifyType,
    autoClose,
    redirectURL,
    isFront
  } = modal;
  const { checkIfNoData } = contestProfile;
  return {
    open,
    message,
    withButton,
    buttonText,
    notifyType,
    autoClose,
    redirectURL,
    isFront,
    checkIfNoData
  };
};

const mapDispatchToProps = dispatch => ({
  modalClose: () => dispatch(actions.modalClose()),
  resetContestProfile: () => dispatch(actions.resetContestProfile())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Modal));
